import api from './axios';

/* ── Report a bug or send a suggestion ───────────────────────────
   POST /api/feedback
   body: { type: 'bug' | 'suggestion', message, page }
   🔒 Requires user token
─────────────────────────────────────────────────────────────── */
export const sendFeedback = async ({ type, message, page }) => {
  const { data } = await api.post('/feedback', { type, message, page });
  return data;
};

/* ── Admin: every report, newest first ───────────────────────────
   GET /api/admin/feedback?status=&type=
   🔒 Admin token — picked up automatically from the /admin prefix
─────────────────────────────────────────────────────────────── */
export const getFeedback = async (params = {}) => {
  const { data } = await api.get('/admin/feedback', { params });
  return data;
};

/* ── Admin: mark open / resolved ─────────────────────────────────
   PATCH /api/admin/feedback/:id
─────────────────────────────────────────────────────────────── */
export const setFeedbackStatus = async (id, status) => {
  const { data } = await api.patch(`/admin/feedback/${id}`, { status });
  return data;
};

/* ── Admin: delete one ───────────────────────────────────────── */
export const deleteFeedback = async (id) => {
  const { data } = await api.delete(`/admin/feedback/${id}`);
  return data;
};

/* ── Admin: clear every resolved report ──────────────────────────
   DELETE /api/admin/feedback/clear
   Only ever removes resolved ones — open reports are never touched.
─────────────────────────────────────────────────────────────── */
export const clearResolvedFeedback = async () => {
  const { data } = await api.delete('/admin/feedback/clear');
  return data;
};
